import {ExtractMediaFileMetadata} from "../../storage/Media";
import {validateFileForUpload} from "../../utils/fileValidation";
import {getFileTypeFromMime, IMAGE_UPLOAD} from "../../utils/utils";

const imageExtensionPattern = /\.(bmp|jpe?g|png|gif|webp)$/i;
const videoExtensionPattern = /\.(mp4|m4v|mov|webm)$/i;

export const getWorkflowUploadFiletype = (file) => {
    const mimeType = String(file?.type || "").trim();
    if (mimeType) {
        const resolvedType = getFileTypeFromMime(mimeType);
        if (resolvedType !== "unknown") {
            return resolvedType;
        }
    }

    const fileName = String(file?.name || "");
    if (imageExtensionPattern.test(fileName)) {
        return IMAGE_UPLOAD;
    }
    if (videoExtensionPattern.test(fileName)) {
        return "video";
    }
    return "audio";
};

export const formatUnsupportedWorkflowFileMessage = (validation) => {
    const extensionText = validation?.codec
        ? `${validation.extension} (${validation.codec})`
        : validation?.extension;
    return `${extensionText} files are not supported in this workflow.`;
};

export async function validateSingleWorkflowFileSelection(file, {
    allowImages = true,
    imageNotAllowedMessage = "Please upload an audio or video file.",
} = {}) {
    const filetype = getWorkflowUploadFiletype(file);
    if (!allowImages && filetype === IMAGE_UPLOAD) {
        return imageNotAllowedMessage;
    }

    const validation = await validateFileForUpload(file);
    if (validation.mode !== "local_ok") {
        return formatUnsupportedWorkflowFileMessage(validation);
    }

    return "";
}

export async function validateWorkflowRequiresAudioStream(file, {
    missingAudioMessage = "This file has no audio stream. This workflow requires audio.",
} = {}) {
    const filetype = getWorkflowUploadFiletype(file);
    if (filetype === IMAGE_UPLOAD) {
        return missingAudioMessage;
    }

    const metadata = await ExtractMediaFileMetadata({
        file,
        fileType: filetype,
    });

    if (!metadata?.hasAudioStream) {
        return missingAudioMessage;
    }

    return "";
}
